import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS7 = props => {
    const ans = '外向行為'
    const select_arr = [
        {
            value: '1',
            label: '領導力強'
        },
        {
            value: '2',
            label: '健談'
        },
        {
            value: '3',
            label: '慷慨'
        },
        {
            value: '4',
            label: '熱心公務'
        },
        {
            value: '5',
            label: '欺侮同學'
        },
        {
            value: '6',
            label: '常講粗話'
        },
        {
            value: '7',
            label: '好遊蕩'
        },
        {
            value: '8',
            label: '愛唱反調'
        }

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s7"
                   type="checkbox"/>
        </div>
    )
}

export default SseS7


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS7.jsx